import { createStore, applyMiddleware } from "redux";
// import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import  thunk  from 'redux-thunk';
import reducers from "./reducers";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store: any = createStore(persistedReducer, applyMiddleware(thunk));


 const persistor = persistStore(store);

export {store, persistor};